import React, { useEffect } from "react";
import {
  Button,
  EmptyModal,
  ImageTilePicker,
  ImageViewer,
  Modal,
  Textarea,
  Textfield,
} from "../../../../components/core";
import { InputNumber } from "primereact/inputnumber";
import { NumberFormatBase } from "react-number-format";
import { useQuery } from "@apollo/client";
import { FILTER_PACKAGES } from "../../../../constants/graphql/view-package-history-queries";
import { Dialog } from "primereact/dialog";

export default function UpdateRecipientMobileModal({
  open = false,
  onClose,
  setRecipientMobile,
  waybillNumber,
  setProofPhoto,
  updateAndSendPickupCode,
  packageState,
  packageId,
}) {
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const [imageViewer, setImageViewer] = React.useState({
    url: "",
    open: false,
  });

  const [imageKeys, setImageKeys] = React.useState({
    proofOfOwnership: 0,
    idPhoto: 0,
  });

  function validateFileType(file) {
    const allowedTypes = ["image/jpeg", "image/jpg"];
    return allowedTypes.includes(file.type);
  }

  function imageToBase64(files, name, event) {
    if (files) {
      const file = files[0];

      // Validate file type
      if (!validateFileType(file)) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Image Error",
          message: `Selected image must strictly be a jpg/jpeg`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        // URL.revokeObjectURL(objectUrl);
        // e.target.value = null;

        // Clear the file input
        event.target.value = "";
        // Force re-render of ImageTilePicker by changing its key
        setImageKeys((prev) => ({
          ...prev,
          [name]: prev[name] + 1,
        }));
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        // The result property contains the base64 encoded data
        const base64String = event.target.result;
        setProofPhoto((prev) => ({
          ...prev,
          [name]: base64String,
        }));
      };

      // Read the file as a data URL (base64 encoded)
      reader.readAsDataURL(file);
    } else {
      console.log(files);
    }
  }

  return (
    <>
      <Dialog
        visible={open}
        onHide={onClose}
        draggable={false}
        resizable={false}
        header="Update Recipient Mobile"
        footer={
          <div className="grid grid-cols-2 gap-4 pt-6">
            <Button
              className={
                "p-2 bg-white border border-primary-primaryYellow hover:bg-gray-200"
              }
              value={"Cancel"}
              onClick={onClose}
            />
            <Button
              className={"p-2 hover:bg-primary-primaryYellowDark"}
              value={"Update & Send Pickupcode"}
              onClick={updateAndSendPickupCode}
            />
          </div>
        }
        className="max-w-[95%] md:max-w-[850px]"
      >
        <div className="w-full">
          <div className="">
            <p className="text-component-blueTextColor mb-4">
              <i>
                Note: The uploaded image must be 1 to 2MB in size, have
                dimensions of 1920 x 1920, and be in JPG format only.
              </i>
            </p>
            <div className="w-full space-y-4">
              {packageState > 300 ? (
                <div className="grid grid-cols-2 gap-2">
                  <p className="my-auto">Package ID:</p>
                  <p className="my-auto">{packageId}</p>
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-2">
                  <p className="my-auto">Waybill Number:</p>
                  <p className="my-auto">{waybillNumber}</p>
                </div>
              )}
              <div className="grid grid-cols-2 gap-2">
                <p className="my-auto">New Recipient Mobile:</p>
                <NumberFormatBase
                  required={true}
                  customInput={Textfield}
                  prefix={"+63"}
                  placeholder={"9XXXXXXXXX"}
                  maxLength={10}
                  onChange={(event) => setRecipientMobile(event.target.value)}
                />
              </div>
              <div>
                <p className="mb-2">Proof of Ownership:</p>
                <ImageTilePicker
                  key={imageKeys.proofOfOwnership}
                  text="Upload Proof (JPG only)"
                  maxWidth={1920}
                  maxHeight={1920}
                  maxSize={2}
                  name="proofOfOwnership"
                  accept="image/jpeg"
                  onChange={(event) => {
                    if (event.target.files && event.target.files[0]) {
                      imageToBase64(
                        event.target.files,
                        "proofOfOwnership",
                        event
                      );
                    }
                  }}
                />
              </div>
              <div>
                <p className="mb-2">ID Photo:</p>
                <ImageTilePicker
                  key={imageKeys.idPhoto}
                  text="Upload ID (JPG only)"
                  maxWidth={1920}
                  maxHeight={1920}
                  maxSize={2}
                  name="idPhoto"
                  accept="image/jpeg"
                  onChange={(event) => {
                    if (event.target.files && event.target.files[0]) {
                      imageToBase64(event.target.files, "idPhoto", event);
                    }
                  }}
                />
              </div>
              {/* <div> */}
              {/* <p className="mb-2">Internal Msg:</p> */}
              {/* <Textarea maxLength={1000} placeholder="Type your message here" onChange={(event) => setRecipientMobile(event.target.value)}  /> */}
              {/* </div> */}
            </div>
            <p className="my-4 font-bold">Sample requirements: </p>
            <div className="flex gap-4 w-full">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/proof.jpg`}
                alt="proof"
                className="w-40 cursor-pointer"
                onClick={() =>
                  setImageViewer((prev) => ({
                    open: true,
                    url: `${process.env.PUBLIC_URL}/assets/images/proof.jpg`,
                  }))
                }
              />
              <img
                alt="proof"
                src={`${process.env.PUBLIC_URL}/assets/images/id.jpg`}
                className="w-40 cursor-pointer"
                onClick={() =>
                  setImageViewer((prev) => ({
                    open: true,
                    url: `${process.env.PUBLIC_URL}/assets/images/id.jpg`,
                  }))
                }
              />
            </div>
            {/* <hr className="my-4"></hr> */}
          </div>
        </div>
        <ImageViewer
          onOpen={imageViewer.open}
          onClose={() => setImageViewer((prev) => ({ ...prev, open: false }))}
          imageUrl={imageViewer.url}
        />
      </Dialog>

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
}
